/*document.addEventListener('click', function(e) {
  const swatchImg = e.target.closest('.ymq-option-swatches-image'); 
  if (!swatchImg) return;

  const getBaseName = (src) => {
    if (!src) return '';
    const filename = src.split('/').pop().split('?')[0]; // Remove path and query
    return filename.split('_')[0].split('.')[0];        // Remove Shopify sizing/extension
  };
  const swatchBase = getBaseName(swatchImg.src);
  const ymqSrc = swatchImg.src.split('/').pop().split('?')[0];
  const coreName = ymqSrc.replace(/^[^-]+-/, '').replace(/-ymq\..+$/, '').split('.')[0];

  if (!coreName) return;

  // 2. Find all gallery images
  const thumbnails = document.querySelectorAll('.product-information__media img'); 

  thumbnails.forEach((thumb) => {
    const thumbSrc = (thumb.src || thumb.dataset.src || "").split('/').pop().split('?')[0];

    // 3. The "Exact Match" Logic
    // This RegEx looks for the coreName as a whole word (boundaries) 
    // so "emma4" matches "emma4.png" but NOT "lemma4rt.png"
    const regex = new RegExp(`(^|[^a-zA-Z0-9])${coreName}([^a-zA-Z0-9]|$)`);

    if (regex.test(thumbSrc)) {
      // 4. Trigger the click on the thumbnail or its parent button
      const trigger = thumb.closest('button') || thumb.closest('a') || thumb;
      trigger.click();
      
      console.log('Matched and clicked:', coreName);
    }
  });
});*/
document.addEventListener('click', function(e) {
  const optionItem = e.target.closest('.ymq-option-value-item');
  if (!optionItem) return;

  // Find the image inside the clicked option
  const swatchImg = optionItem.querySelector('.ymq-option-swatches-image');
  if (!swatchImg) return;

  const getBaseName = (src) => {
    if (!src) return '';
    const filename = src.split('/').pop().split('?')[0];
    return filename.split('_')[0].split('.')[0];
  };

  const swatchBase = getBaseName(swatchImg.src);
  const ymqSrc = swatchImg.src.split('/').pop().split('?')[0];
  const coreName = ymqSrc
    .replace(/^[^-]+-/, '')
    .replace(/-ymq\..+$/, '')
    .split('.')[0];

  if (!coreName) return;

  const thumbnails = document.querySelectorAll('.product-information__media img');

  thumbnails.forEach((thumb) => {
    const thumbSrc = (thumb.src || thumb.dataset.src || "")
      .split('/')
      .pop()
      .split('?')[0];

    const regex = new RegExp(`(^|[^a-zA-Z0-9])${coreName}([^a-zA-Z0-9]|$)`);

    if (regex.test(thumbSrc)) {
      const trigger = thumb.closest('button') || thumb.closest('a') || thumb;
      trigger.click();

      console.log('Matched and clicked:', coreName);
    }
  });
});